import axios from './../index'

class role {

    /**
     * 添加角色
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    static addRole(params) {
        return axios.post(`/app-admin/sys/role/insert`,params)
    }

    /**
     * 角色列表
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    static roleListPage(params) {
        return axios.get(`/app-admin/sys/role/list`,{params:params})
    }
    //编辑角色
    static roleEdit(params) {
        return axios.post(`/app-admin/sys/role/update`,params)
    }

    //角色列表
    static roleList(params) {
        return axios.get(`/app-admin/sys/role/list-all`,{params:params})
    }
    //账号开关
    static switchState(roleId) {
        return axios.post(`/app-admin/sys/role/switchState/${roleId}`)
    }

}

export default role;
